export function normalizeApiData(result: Response, response: any) {
  return {
    code: result.status,
    status: result.ok,
    data: response,
  };
}
